import { ITimePeriodRequest } from '@lla-platform/core/core-data-access'

export class GetShopsTargetsByPeriod {
  static readonly type = '[PeriodTarget] Get Shops Targets By Period'
  constructor(public payload: ITimePeriodRequest) {}
}

export class GetShopsTargetsByPeriodDetails {
  static readonly type = '[PeriodTarget] Get Shops Targets By Period Details'
  constructor(
    public payload: ITimePeriodRequest,
    public locationIds: string[]
  ) {}
}
